module.exports = __webpack_public_path__ + "static/media/cafe.eaf18296.jpg";